/* eslint-disable import/prefer-default-export */
import { canUseDOM } from '@surfline/web-common';

export const getMapPageHeight = () => {
  if (canUseDOM) {
    return { height: `${window.innerHeight - 96}px` };
  }

  return {
    height: '0px',
  };
};

export const getMapPageWidth = () => {
  if (canUseDOM) {
    return window.innerWidth;
  }

  return 0;
};
